
export const initialLoginFormState = {
  message: 'Please log in to continue.'
};

export const initialFieldConfigFormState = {};

export default {
    main: {
        isLoggedIn: false,
        token: null,
        username: null,
        userId: 0,
        photo: null,
        sidebarNavActive: false,
        errors: [],
        notification: {
            show: false,
            type: "info",
            message: ""
        },
        formTemplate: {},
        makingRequest: false,
        screenWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    },
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js